document.addEventListener('DOMContentLoaded', () => {
  const toggles = document.querySelectorAll('.usp-toggle button')
  const accordions = document.querySelectorAll('.horizontal-accordion')

  accordions.forEach((accordion, index) => {
    accordion.classList.toggle('visible', index === 0)
    accordion.classList.toggle('hidden', index !== 0)
  })
  toggles[0]?.classList.add('active')

  toggles.forEach((button, index) => {
    button.addEventListener('click', () => {
      accordions.forEach((accordion, i) => {
        accordion.classList.toggle('visible', i === index)
        accordion.classList.toggle('hidden', i !== index)
      })

      toggles.forEach(btn => btn.classList.remove('active'))
      button.classList.add('active')
    })
  })
})

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.horizontal-accordion').forEach(accordion => {
        const sections = accordion.querySelectorAll('.section')

        if (sections.length > 0) {
            sections[0].classList.add('grow')
            sections[0].classList.remove('shrink')
            sections[0].setAttribute('aria-expanded', 'true')

            const firstText = sections[0].querySelector('.main-text')
            if (firstText) {
                firstText.classList.add('show')
                firstText.classList.remove('hide')
            }
        }

        sections.forEach(section => {
            section.addEventListener('click', () => {
                const isMobile = window.innerWidth <= 768

                if (section.classList.contains('grow')) {
                    if (isMobile) {
                        section.classList.replace('grow', 'shrink')
                        section.setAttribute('aria-expanded', 'false')

                        const text = section.querySelector('.main-text')
                        if (text) {
                            text.classList.replace('show', 'hide')
                        }
                    }

                    return
                }

                sections.forEach(s => {
                    s.classList.replace('grow', 'shrink')
                    s.setAttribute('aria-expanded', 'false')

                    const text = s.querySelector('.main-text')
                    if (text) {
                        text.classList.replace('show', 'hide')
                    }
                })

                section.classList.replace('shrink', 'grow')
                section.setAttribute('aria-expanded', 'true')

                setTimeout(() => {
                    const text = section.querySelector('.main-text')
                    if (text) {
                        text.classList.replace('hide', 'show')
                    }
                }, 300)

                if (isMobile) {
                    const offset = 90
                    const sectionTop = section.getBoundingClientRect().top + window.scrollY
                    window.scrollTo({ top: sectionTop - offset, behavior: 'smooth' })
                }
            })
        })
    })
})

document.addEventListener('DOMContentLoaded', function () {
  const uspToggle = document.querySelector('.usp-toggle')
  if (!uspToggle) return

  const buttons = uspToggle.querySelectorAll('button')
  const activeClass = 'active'
  const activeButton = uspToggle.querySelector('button.active')

  requestAnimationFrame(() => {
    if (activeButton) {
      doCalculations(activeButton)
    }
  })

  for (const button of buttons) {
    button.addEventListener('click', function (e) {
      e.preventDefault()
      const currentlyActive = uspToggle.querySelector('button.active')
      if (currentlyActive) {
        currentlyActive.classList.remove(activeClass)
      }
      button.classList.add(activeClass)
      doCalculations(button)
    })
  }

  function doCalculations(button) {
    if (!button) return
    uspToggle.style.setProperty('--transform-js', `${button.offsetLeft}px`)
    uspToggle.style.setProperty('--width-js', `${button.offsetWidth}px`)
  }

  window.addEventListener('resize', function () {
    const activeButton = uspToggle.querySelector('button.active')
    if (activeButton) {
      doCalculations(activeButton)
    }
  })
})
